function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 7a6 6 0 116 6 6.007 6.007 0 01-6-6zm1.2 0a4.8 4.8 0 109.6.001A4.8 4.8 0 002.2 7V7zm2 0a2.8 2.8 0 115.6 0 2.8 2.8 0 01-5.6 0z",
  fill: "currentColor"
});

var SvgActive = function SvgActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgActive;